module.exports = "<gw-account-payment billing-info-promise=\"$ctrl.billingInfoPromise\" billing-info=\"$ctrl.billingInfo\"/>"